import logger from "@next/core-logger"
import {IncomingHttpHeaders} from "http"
import {axiosInstance as axios} from "../../utils/axios"

import {PrimaryNav, DefaultConfig} from "../../models/primary-nav"
import AppApiConfig from "../../config/api/meganavdata"
import {REALM_HEADER} from "../../config/constants"
import {defaultPrimaryData} from "./defaultPrimaryNavData"

// this will always be called server-side on first render and subsequent server-side renders
export const getPrimaryNavData = async (
    headers: IncomingHttpHeaders,
    defaultPrimaryConfig: DefaultConfig,
    queryParameters: string,
): Promise<PrimaryNav> => {
    try {
        const getAppDataApi = AppApiConfig("getPrimaryNavData")
        const response = await axios({
            method: getAppDataApi.method,
            url: `${getAppDataApi.localEndpoint()}?${queryParameters}`,
            headers: headers as {
                [header: string]: string
            },
        })

        return response.data
    } catch (error) {
        const ex = error as Error
        logger.error(ex)
        const defaultData = await defaultPrimaryData(headers[REALM_HEADER], defaultPrimaryConfig)
        return defaultData
    }
}
